import { Headline } from 'components/Headline';
import { Modal } from 'components/Modal';

import { StatusItem } from '../StatusItem';
import * as S from './ConnectionStatus.styles';

type ConnectionStatusProps = {
  isVisibleSet: (arg0: boolean) => void;
};

export type StatusItemType = {
  id: number;
  label: string;
  status: boolean;
};

const defaultProps: Partial<ConnectionStatusProps> = {};

const statusData: StatusItemType[] = [
  {
    id: 1,
    label: 'Test connessione internet:',
    status: true,
  },
  {
    id: 2,
    label: 'Test connessione al server API:',
    status: true,
  },
  {
    id: 3,
    label: 'Test connessione al server WEB:',
    status: true,
  },
];

export function ConnectionStatus(props: ConnectionStatusProps): React.ReactElement {
  const { isVisibleSet } = { ...defaultProps, ...props };

  const statusDataMapped = statusData?.map((item: StatusItemType) => (
    <StatusItem key={item.id} label={item.label} status={item.status} />
  ));

  return (
    <Modal onClose={() => isVisibleSet(false)}>
      <S.Header>
        <Headline tag="h3" scale="xl2">
          Connection Status
        </Headline>
      </S.Header>

      {statusData && statusDataMapped}
    </Modal>
  );
}
